import React from "react"
import {Data} from "./Data"

export default function App(){
  return(
    <div>
      <ol>
        {
        Data.map((name,ind) => {
          return(
            <li className="list-item" key={ind}>{name}</li>
          )
        }
        )}
      </ol>
    </div>
  )
}